class PhrasesService {
    constructor() {
        this.phrases = {};

        if (!window._data.phrases) {
            return;
        }

        for (var i = 0; i < window._data.phrases.length; i++) {
            var phrase = window._data.phrases[i];
            this.phrases[phrase.T] = phrase.V;
        }
    }

    getPhrase(title) {
        if (!this.phrases[title]) {
            return title;
        }

        return this.phrases[title];
    }
}

PhrasesService.shared = new PhrasesService();
class DnsService {
    constructor() {

    }

    async isEmailDomainValid(email) {
        const atIndex = email.indexOf('@')
        if (atIndex < 0) {
            return false
        }

        const domain = encodeURIComponent(email.substr(atIndex + 1))
        const resolveResponse = await fetch('https://dns.google/resolve?type=MX&name=' + domain)
        const resolveResult = await resolveResponse.json()
        if (!resolveResult
            || !resolveResult.Answer
            || !resolveResult.Answer.length) {
            return false
        }

        return true
    }
}

DnsService.shared = new DnsService()
class GoogleService {
    constructor() {
    }

    signIn(clientId, success, error) {
        const googleAuthClientScope = 'https://www.googleapis.com/auth/userinfo.email';

        const googleAuthClient = google.accounts.oauth2.initTokenClient({
            client_id: clientId,
            scope: googleAuthClientScope,
            callback: (tokenResponse) => {
                if (!tokenResponse || !tokenResponse.access_token) {
                    console.error(tokenResponse, "No token");
                    error(tokenResponse, "No token");
                    return;
                }

                if (!google.accounts.oauth2.hasGrantedAnyScope(tokenResponse, googleAuthClientScope)) {
                    console.error(tokenResponse, "Required scope not found");
                    error(tokenResponse, "Required scope not found");
                    return;
                }

                success(tokenResponse.access_token);
            },
        });

        googleAuthClient.requestAccessToken();
    }
}

GoogleService.shared = new GoogleService()
class SecurityService {
    constructor(siteKey) {
        this._siteKey = siteKey;
    }

    async getGoogleReCaptchaToken(action) {
        const token = await grecaptcha.execute(
            this._siteKey,
            {
                action: action
            }
        );
        return token;
    }
}

SecurityService.shared = new SecurityService(window._data.googleReCaptchaSiteKey);
Vue.component('guest-invitation', {
        props: {
            invitationId: {
                type: String,
                required: true
            },
            languageId: {
                type: String,
                required: true
            },
            apiBaseUrl: {
                type: String,
                required: true
            },
            hostAppPrefix: {
                type: String,
                required: true
            }
        },

        data: function () {
            return {
                event: null,
                invitations: [],
                phrases: {
                    yourticket: PhrasesService.shared.getPhrase('guestinvitation_yourticket'),
                    inviteyourfriends: PhrasesService.shared.getPhrase('guestinvitation_inviteyourfriends'),
                    makesure: PhrasesService.shared.getPhrase('guestinvitation_makesure'),
                    // firstname: PhrasesService.shared.getPhrase('guestinvitation_firstname'),
                    // lastname: PhrasesService.shared.getPhrase('guestinvitation_lastname'),
                    fullName: PhrasesService.shared.getPhrase('guestinvitation_fullname'),
                    createinvitation: PhrasesService.shared.getPhrase('guestinvitation_createinvitation'),
                    guest: PhrasesService.shared.getPhrase('guestinvitation_guest'),
                    sendinvitation: PhrasesService.shared.getPhrase('guestinvitation_sendinvitation'),
                    deleteinvitation: PhrasesService.shared.getPhrase('guestinvitation_deleteinvitation'),
                    error: PhrasesService.shared.getPhrase('guestinvitation_error'),
                    downloadpdf: PhrasesService.shared.getPhrase('guestinvitation_downloadpdf'),
                    invitationdeleted: PhrasesService.shared.getPhrase('guestinvitation_invitationdeleted'),
                    ifinvitationissend: PhrasesService.shared.getPhrase('guestinvitation_ifinvitationissend'),
                    understand: PhrasesService.shared.getPhrase('guestinvitation_understand'),
                    agecontrol: PhrasesService.shared.getPhrase('guestinvitation_agecontrol'),
                    buyTicket: PhrasesService.shared.getPhrase('guestinvitation_buyticket'),
                    ticketPrice: PhrasesService.shared.getPhrase('guestinvitation_ticketprice')
                },
                httpClient: null,
                selectedDiscountPercent: null,
                modalPopupInvitation: null
            };
        },

        methods: {
            isModalPopupInvitationVisible() {
                return !!this.modalPopupInvitation
            },

            async loadInvitation() {
                this.event = null

                try {
                    const resp = await this.httpClient.get("/GetInvitation")
                    this.event = resp.data
                }
                catch (err) {
                    console.error(err)
                    this.event = null
                    return
                }

                if (!this.event) {
                    return
                }

                this.generateInvitations()
                this.selectFirstAvailableInvitationDiscountPercent()
            },

            roleMinPrice(role) {
                if (!role) {
                    return "--"
                }

                if (role.ticketMinimalPrice) {
                    return role.ticketMinimalPrice;
                }

                return 0;
            },

            // getCreateInvitationButtonClasses() {
            //     return {
            //         "loading": this.newInvitation.sending,
            //         "disabled": !this.isNewGuestInputDataValid
            //     }
            // },

            getSaveButtonClasses(invitation) {
                return {
                    "disabled": !this.isInvitationValid(invitation),
                    "loading": invitation.loading
                }
            },

            getInviteButtonClasses(invitation) {
                return {
                    "disabled": !this.isInvitationValid(invitation),
                    "loading": invitation.loading
                }
            },

            getInvitationItemClasses(invitation) {
                return {
                    "editing": invitation.isEditing,
                    "disabled": !invitation.isEmpty && (!invitation.isEditing || invitation.loading)
                }
            },

            generateTicketUrl(ticket) {
                return this.hostAppPrefix + "/viewticket/?i=" + ticket.id;
            },

            generateShareableTicketUrl(ticket) {
                return this.hostAppPrefix + "/viewticket/?i=" + ticket.id + "&share=true";
            },

            //isMobileView() {
            //    return this.$refs.mobileqr.offsetParent !== null;
            //},

            async shareTicket(ticket) {
                let url = this.generateTicketUrl(ticket);
                let shareData = {
                    url: url
                };

                if (!this.canNavigatorShareUrl(shareData)) {
                    this.openUrlInNewTab(url);
                    return;
                }

                try {
                    await navigator.share(shareData);
                } catch (err) {
                    this.openUrlInNewTab(url);
                }
            },

            openUrlInNewTab(ticketUrl) {
                window.open(ticketUrl)
            },

            canNavigatorShareUrl(shareData) {
                if (!this.isMobileView()) {
                    return false;
                }

                try {
                    return navigator.canShare
                        && navigator.canShare(shareData);
                }
                catch (err) {
                    return false;
                }
            },

            openTicketInNewTab(ticket) {
                let url = this.generateTicketUrl(ticket);
                window.open(url);
            },

            //copyTicketUrlToClipboard(event, ticket) {
            //    let url = this.generateTicketUrl(ticket);
            //    let targetElem = event.currentTarget;

            //    navigator.clipboard.writeText(url);

            //    targetElem.classList.toggle('active', true);

            //    setTimeout(() => {
            //        targetElem.classList.toggle('active', false);
            //    }, 1500);
            //},

            buyTicketMessage(price) {
                const template = this.phrases.buyTicket
                const message = template.replace('{PRICE}', price).replace(/\s/g, '&nbsp;')
                return message
            },

            ticketPriceMessage(price) {
                const template = this.phrases.ticketPrice
                const message = template.replace('{PRICE}', price).replace(/\s/g, '&nbsp;')
                return message
            },

            openOwnTicket() {
                this.openTicketInNewTab(this.event.guestTicket);
            },

            ticketNeedsPurchasing(ticket) {
                const needsPurchasing =
                    ticket.paymentStatus != 30 /*Paid*/
                    && ticket.paymentStatus != 100 /*NotRequired*/

                return needsPurchasing
            },

            canSendFreeTicket() {
                const canSend = this.event.invitations.maxMinPrice > this.sentFreeInvitationsCount
                return canSend
            },

            canSendHalfPriceTicket() {
                const canSend = this.event.invitations.maxHalfPrice > this.sentHalfPriceInvitationsCount
                return canSend
            },

            canSendFullPriceTicket() {
                const canSend = this.event.invitations.maxFullPrice > this.sentFullPriceInvitationsCount
                return canSend
            },

            selectFirstAvailableInvitationDiscountPercent() {
                this.selectedDiscountPercent = null;


                const availableFree = this.event.invitations.maxMinPrice - this.sentFreeInvitationsCount;
                const availableHalfPrice = this.event.invitations.maxHalfPrice - this.sentHalfPriceInvitationsCount;
                const availableFullPrice = this.event.invitations.maxFullPrice - this.sentFullPriceInvitationsCount;

                if (availableFree > 0) {
                    this.selectedDiscountPercent = "100";
                    return;
                }

                if (availableHalfPrice > 0) {
                    this.selectedDiscountPercent = "50";
                    return;
                }

                if (availableFullPrice > 0) {
                    this.selectedDiscountPercent = "0";
                    return;
                }
            },

            allowedInvitationTypesCount() {
                let count = 0;
                if (this.event.invitations.maxMinPrice > 0) count++;
                if (this.event.invitations.maxHalfPrice > 0) count++;
                if (this.event.invitations.maxFullPrice > 0) count++;
                return count;
            },

            startEditing(invitation) {
                //invitation.originalFirstName = invitation.firstName;
                //invitation.originalLastName = invitation.lastName;
                invitation.originalFullName = invitation.fullName
                invitation.isEditing = true
            },

            cancelInvitationEdit(invitation) {
                // invitation.firstName = invitation.originalFirstName;
                // invitation.lastName = invitation.originalLastName;
                invitation.fullName = invitation.originalFullName
                // invitation.originalFirstName = null;
                // invitation.originalLastName = null;
                invitation.originalFullName = null
                invitation.isEditing = false
            },


            isInvitationValid(invitation) {
                return invitation.firstName?.length >= 2
                    && invitation.lastName?.length >= 2;
            },

            async saveInvitation(invitation) {
                if (!this.isInvitationValid(invitation)) {
                    return;
                }

                Vue.set(invitation, 'loading', true)

                if (invitation.isEmpty) {
                    try {
                        const resp = await this.httpClient.post("/CreateGuestTicket", {
                            FirstName: invitation.firstName,
                            LastName: invitation.lastName,
                            DiscountPercent: invitation.discountPercent
                        });

                        Object.assign(invitation, resp.data);
                        invitation.isEmpty = false;
                        invitation.isEditing = false;

                        this.showTicketModal(invitation)
                    } catch (err) {
                        const errorMessage = err.response?.data ?? err;
                        alert(errorMessage);
                        console.error(err);
                    }
                } else {
                    try {
                        const resp = await this.httpClient.put("/UpdateGuestTicket", {
                            id: invitation.id,
                            FirstName: invitation.firstName,
                            LastName: invitation.lastName
                        });

                        Object.assign(invitation, resp.data);
                        invitation.isEmpty = false;
                        invitation.isEditing = false;

                        this.showTicketModal(invitation)
                    } catch (err) {
                        const errorMessage = err.response?.data ?? err;
                        alert(errorMessage);
                        console.error(err);
                    }
                }

                invitation.loading = false
            },

            async copyInvitationLink(invitation) {
                const url = this.generateTicketUrl(invitation);
                try {
                    await navigator.clipboard.writeText(url);
                    // TODO: Show success toast
                } catch (err) {
                    console.error(err);
                }
            },

            showTicketModal(invitation) {
                this.modalPopupInvitation = invitation
                document.body.classList.toggle("noscroll", true)
            },

            hideTicketModal(e) {
                debugger
                var shouldClose =
                    e.currentTarget.classList.contains('js-guest-invitation-modal-close') ||
                    e.currentTarget.classList.contains('js-guest-invitation-modal');

                if (!shouldClose) {
                    return
                }

                this.modalPopupInvitation = null
                document.body.classList.toggle("noscroll", false)

            },

            //async shareInvitation(invitation) {
            //    const url = this.generateTicketUrl(invitation);
            //    const shareData = { url };

            //    if (this.canNavigatorShareUrl(shareData)) {
            //        try {
            //            await navigator.share(shareData);
            //        } catch (err) {
            //            this.openUrlInNewTab(url);
            //        }
            //    } else {
            //        this.openUrlInNewTab(url);
            //    }
            //},

            generateInvitations() {
                if (!this.event?.invitations?.tickets) {
                    this.invitations = [];
                    return;
                }

                const invitations = [];

                const existingTickets = {
                    100: this.event.invitations.tickets.filter(t => t.discountPercent === 100) || [],
                    50: this.event.invitations.tickets.filter(t => t.discountPercent === 50) || [],
                    0: this.event.invitations.tickets.filter(t => t.discountPercent === 0) || []
                };

                const categories = [
                    { discount: 100, max: this.event.invitations.maxMinPrice },
                    { discount: 50, max: this.event.invitations.maxHalfPrice },
                    { discount: 0, max: this.event.invitations.maxFullPrice }
                ];

                categories.forEach(category => {
                    const ticketsWithFlags = existingTickets[category.discount].map(ticket => ({
                        ...ticket,
                        isEditing: false,
                        isEmpty: false,
                        fullName: `${ticket.firstName} ${ticket.lastName}`
                    }));
                    invitations.push(...ticketsWithFlags);

                    const emptyCount = Math.max(0, category.max - existingTickets[category.discount].length);
                    for (let i = 0; i < emptyCount; i++) {
                        invitations.push({
                            isEmpty: true,
                            isEditing: false,
                            firstName: '',
                            lastName: '',
                            fullName: '',
                            discountPercent: category.discount
                        });
                    }
                });

                this.invitations = invitations;
            },

            shouldShowEditButton(invitation) {
                return !invitation.isEmpty && !invitation.isEditing;
            },

            shouldShowInviteButton(invitation) {
                return invitation.isEmpty;
            },

            shouldShowSaveButton(invitation) {
                return invitation.isEditing;
            },

            shouldShowCancelButton(invitation) {
                return !invitation.isEmpty && invitation.isEditing && !invitation.loading;
            },

            shouldShowCopyLinkButton(invitation) {
                return !invitation.isEmpty && !invitation.isEditing;
            },

            shouldShowOpenTicketButton(invitation) {
                return !invitation.isEmpty && !invitation.isEditing;
            },

            isInvitationInputDisabled(invitation) {
                return !invitation.isEmpty && !invitation.isEditing;
            },

            onFullNameInput(invitation) {
                if (!invitation.fullName) {
                    invitation.firstName = ''
                    invitation.lastName = ''
                    return
                }
                invitation.firstName = invitation.fullName.split(' ')[0] || ''
                invitation.lastName = invitation.fullName.split(' ').slice(1).join(' ') || ''
            },

            shouldShowOwnTicketPrice() {
                if (!this.event?.guestTicket) {
                    return false
                }
                return this.event.guestTicket.price > 0 && this.ticketNeedsPurchasing(this.event.guestTicket)
            },

            formatOwnTicketButtonText() {
                if (!this.event?.guestTicket) {
                    return 'Open Your Ticket'
                }
                
                const price = Math.floor(this.event.guestTicket.price)
                const currency = '₾' // Default currency, you can add logic to determine EUR vs GEL if needed
                return `Pay ${price}${currency} - Open Your Ticket`.replace(/\s/g, '\u00A0')
            }
        },

        async mounted() {
            this.httpClient = axios.create({
                baseURL: this.apiBaseUrl,
            });
            this.httpClient.defaults.headers.common['i'] = this.invitationId;
            this.httpClient.defaults.headers.common['l'] = this.languageId;

            await this.loadInvitation();
        },

        computed: {
            showOwnTicket() {
                return !!this.event.guestTicket;
            },

            showInvitations() {
                if (!this.event.invitations) {
                    return false
                }

                const maxInvitations = this.event.invitations.maxMinPrice + this.event.invitations.maxHalfPrice + this.event.invitations.maxFullPrice
                return maxInvitations > 0
                    || (this.event.invitations.tickets && this.event.invitations.tickets.length > 0)

            },

            canSendInvitation() {
                if (!this.event.invitations) {
                    return false
                }

                const maxInvitations = this.event.invitations.maxMinPrice + this.event.invitations.maxHalfPrice + this.event.invitations.maxFullPrice

                return maxInvitations > 0
                    && (
                        !this.event.invitations.tickets
                        || this.event.invitations.tickets.length < maxInvitations
                    );
            },

            sentFreeInvitationsCount() {
                const invitations = this.event.invitations?.tickets.filter(t => t.discountPercent == 100)
                const count = invitations?.length ?? 0
                return count
            },

            sentHalfPriceInvitationsCount() {
                const invitations = this.event.invitations?.tickets.filter(t => t.discountPercent == 50)
                const count = invitations?.length ?? 0
                return count
            },

            sentFullPriceInvitationsCount() {
                const invitations = this.event.invitations?.tickets.filter(t => t.discountPercent == 0)
                const count = invitations?.length ?? 0
                return count
            },

            productHalfPrice() {
                return this.event.productPrice / 2
            },

            productFullPrice() {
                return this.event.productPrice
            },

            filteredInvitations() {
                if (this.selectedDiscountPercent === null) {
                    return this.invitations;
                }
                return this.invitations.filter(invitation =>
                    invitation.discountPercent === parseInt(this.selectedDiscountPercent)
                );
            },

            groupedInvitations() {
                const groups = [];

                if (this.invitations.filter(i => i.discountPercent === 100).length > 0) {
                    groups.push({
                        discountPercent: 100,
                        price: this.roleMinPrice(this.event.role),
                        invitations: this.invitations.filter(i => i.discountPercent === 100)
                    });
                }

                if (this.invitations.filter(i => i.discountPercent === 50).length > 0) {
                    groups.push({
                        discountPercent: 50,
                        price: this.productHalfPrice,
                        invitations: this.invitations.filter(i => i.discountPercent === 50)
                    });
                }

                if (this.invitations.filter(i => i.discountPercent === 0).length > 0) {
                    groups.push({
                        discountPercent: 0,
                        price: this.productFullPrice,
                        invitations: this.invitations.filter(i => i.discountPercent === 0)
                    });
                }

                return groups;
            },
        }
    ,
template: `
    <div>
        <div class="events-loading" v-if="!event">
            <svg id="mzesumzira-loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 174.06 176.75">
                <path d="M87,59.84a28.54,28.54,0,1,0,28.53,28.53A28.53,28.53,0,0,0,87,59.84Zm0,32.58a4,4,0,1,1,4-4A4,4,0,0,1,87,92.42Z">
                </path>
                <path d="M174.06,103.72a95.84,95.84,0,0,0-8.93-13c-.65-.8-1.31-1.58-2-2.36.66-.77,1.32-1.55,2-2.36a95.08,95.08,0,0,0,8.93-13,94.74,94.74,0,0,0-12.83-9.15c-.89-.54-1.78-1-2.66-1.54.35-1,.7-1.92,1-2.9a95.24,95.24,0,0,0,3.95-15.25A93.6,93.6,0,0,0,148.37,40c-1-.2-2-.37-3-.54,0-1,0-2,0-3.08a94.11,94.11,0,0,0-1.51-15.68,95,95,0,0,0-15.71,1.23l-3,.53c-.34-1-.68-1.92-1-2.88a94.69,94.69,0,0,0-6.79-14.23,94.89,94.89,0,0,0-14.34,6.54c-.92.51-1.82,1-2.71,1.56-.65-.8-1.31-1.59-2-2.38A96,96,0,0,0,87,0,95.26,95.26,0,0,0,75.85,11.05c-.7.8-1.37,1.61-2,2.42-.9-.53-1.8-1.06-2.73-1.58A95.66,95.66,0,0,0,56.8,5.33a95.78,95.78,0,0,0-6.73,14.2c-.37,1-.73,2-1.07,3-1-.19-2.06-.38-3.11-.55a95.42,95.42,0,0,0-15.67-1.27,96.47,96.47,0,0,0-1.46,15.64c0,1.07,0,2.12,0,3.16-1,.17-2.06.35-3.11.55a95.7,95.7,0,0,0-15.16,4.16,95.84,95.84,0,0,0,4,15.2c.35,1,.72,2,1.08,3-.91.51-1.82,1-2.73,1.58A94.22,94.22,0,0,0,0,73,96.29,96.29,0,0,0,8.93,86c.68.82,1.36,1.62,2,2.41-.68.79-1.36,1.6-2,2.42A96.29,96.29,0,0,0,0,103.72a96,96,0,0,0,12.82,9.09c.91.55,1.82,1.07,2.73,1.58-.36,1-.73,2-1.08,3a96,96,0,0,0-4,15.21,95.7,95.7,0,0,0,15.16,4.16c1.05.2,2.08.37,3.11.54,0,1.05,0,2.1,0,3.16a96.48,96.48,0,0,0,1.46,15.65,95.37,95.37,0,0,0,15.67-1.28c1-.17,2.08-.35,3.11-.55.34,1,.7,2,1.07,3a95.87,95.87,0,0,0,6.73,14.21,95.66,95.66,0,0,0,14.29-6.56c.93-.52,1.83-1.05,2.73-1.58.66.8,1.33,1.61,2,2.42A96,96,0,0,0,87,176.75,96.83,96.83,0,0,0,98.21,165.7c.68-.79,1.34-1.59,2-2.38.89.52,1.79,1.05,2.71,1.56a95.89,95.89,0,0,0,14.34,6.54A95.16,95.16,0,0,0,124,157.19c.37-1,.71-1.93,1-2.89,1,.19,2,.37,3,.53a94.9,94.9,0,0,0,15.71,1.24,94.22,94.22,0,0,0,1.51-15.69c0-1,0-2.06,0-3.07,1-.17,2-.34,3-.54a95.68,95.68,0,0,0,15.19-4.21,95.1,95.1,0,0,0-3.95-15.26c-.34-1-.69-1.94-1-2.89.88-.5,1.77-1,2.66-1.54A95.63,95.63,0,0,0,174.06,103.72ZM87,153.37a65,65,0,1,1,65-65A65,65,0,0,1,87,153.37Z">
                </path>
                <path class="cls-1"
                      d="M87,59.84a28.54,28.54,0,1,0,28.53,28.53A28.53,28.53,0,0,0,87,59.84Zm0,32.58a4,4,0,1,1,4-4A4,4,0,0,1,87,92.42Z">
                </path>
                <path d="M87,59.84a28.54,28.54,0,1,0,28.53,28.53A28.53,28.53,0,0,0,87,59.84Zm0,32.58a4,4,0,1,1,4-4A4,4,0,0,1,87,92.42Z">
                </path>
            </svg>
        </div>

        <div v-if="event" class="guest-invitation__content">

            <div v-if="isModalPopupInvitationVisible()" class="js-guest-invitation-modal guest-invitation__modal" @click.prevent="hideTicketModal($event)">
                <iframe class="guest-invitation__modal-iframe" :src="generateShareableTicketUrl(modalPopupInvitation)"></iframe>
                <a @click.prevent="hideTicketModal($event)" href="" class="js-guest-invitation-modal-close guest-invitation__modal-close">
                    <svg><use xlink:href="~/m/i/icons.svg#symbol-times"></use></svg>
                </a>
            </div>

            <div class="guest-invitation__static-content">
                <div class="guest-invitation__event">
                    <a href="javascript:void(0)" class="event__item">
                        <div class="event__image">
                            <img :src="event.posterUrl" alt="">
                        </div>
                        <div class="event__info-wrap">
                            <div class="event__info">
                                <h3 class="event__title" v-html="event.titleHtml"></h3>
                                <div class="event__additional-info">
                                    <div class="event__date-wrap">
                                        <p v-for="(dateText, idx) in event.dateTexts" :key="idx">{{ dateText }}</p>
                                    </div>
                                    <div class="event__age-restriction">
                                        <p>{{ phrases.agecontrol }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="guest-invitation__ticket">
                    <div v-if="showOwnTicket" class="guest-invitation__ticket-info">
                        <span class="guest-invitation__ticket-key">{{ phrases.yourticket }}</span>
                        <span class="guest-invitation__ticket-value">
                            {{ event.guestTicket.firstName }} {{ event.guestTicket.lastName }}
                        </span>
                    </div>

                    <div v-if="showOwnTicket" class="guest-invitation__ticket-qr">
                        <a @click.prevent="openOwnTicket()" href="" class="button button__default button__black">
                            <span class="button__text" v-if="shouldShowOwnTicketPrice()">
                                {{ formatOwnTicketButtonText() }}
                            </span>
                            <span class="button__text" v-else>Open&nbsp;Your&nbsp;Ticket</span>
                        </a>
                    </div>
                </div>
            </div>

            <div v-if="showInvitations" class="guest-invitation__invite">
                <div class="guest-invitation__info">

                    <div class="guest-invitation__info-head">
                        <h3 class="guest-invitation__info-title">{{ phrases.inviteyourfriends }}</h3>

                        <div class="guest-invitation__info-limit">

                        </div>
                    </div>

                    <div class="guest-invitation__info-text" v-html="phrases.makesure">
                    </div>

                </div>

                <div class="guest-invitation__list">
                    <template v-for="(priceGroup, groupIndex) in groupedInvitations">
                        <!-- Price group label -->
                        <div :key="'label-' + groupIndex" class="guest-invitation__list-group-label">
                            <span class="form__options-title">
                                {{ priceGroup.invitations.length }} Tickets for {{ priceGroup.price }}₾
                            </span>
                        </div>

                        <!-- Invitations in this price group -->
                        <div v-for="(invitation, index) in priceGroup.invitations"
                             :key="'invitation-' + groupIndex + '-' + index"
                             :class="getInvitationItemClasses(invitation)"
                             class="guest-invitation__list-item">

                            <div class="form__group">
                                <div class="form__content">
                                    <input class="form__input" type="text"
                                           v-model="invitation.fullName" :disabled="isInvitationInputDisabled(invitation)"
                                           @input="onFullNameInput(invitation)"
                                           :placeholder="phrases.fullName" />
                                </div>
                            </div>

                            <!-- <div class="form__group">
                                <div class="form__content">
                                    <input v-model="invitation.firstName" :disabled="isInvitationInputDisabled(invitation)"
                                           class="form__input" type="text" :placeholder="phrases.firstname" />
                                </div>
                            </div>

                            <div class="form__group">
                                <div class="form__content">
                                    <input v-model="invitation.lastName" :disabled="isInvitationInputDisabled(invitation)"
                                           class="form__input" type="text" :placeholder="phrases.lastname" />
                                </div>
                            </div> -->

                            <div class="guest-invitation__actions">
                                <a href="" v-if="shouldShowInviteButton(invitation)" class="guest-invitation__button button button__black button__small"
                                   @click.prevent="saveInvitation(invitation)"
                                   :disabled="!isInvitationValid(invitation)"
                                   :class="getInviteButtonClasses(invitation)">
                                    Invite
                                    <spinner></spinner>
                                </a>

                                <a :href="generateShareableTicketUrl(invitation)" v-if="shouldShowOpenTicketButton(invitation)" target="_blank"
                                   class="guest-invitation__button button button__black button__small">
                                    Open
                                </a>

                                <a href="" v-if="shouldShowSaveButton(invitation)" class="guest-invitation__button button button__black button__small"
                                   @click.prevent="saveInvitation(invitation)"
                                   :disabled="!isInvitationValid(invitation)"
                                   :class="getSaveButtonClasses(invitation)">
                                    Save
                                    <spinner></spinner>
                                </a>
                                <a href="" v-if="shouldShowCancelButton(invitation)" @click.prevent="cancelInvitationEdit(invitation)"
                                   class="guest-invitation__button button button__link button__small">
                                    Cancel
                                </a>

                                <a href="" v-if="shouldShowEditButton(invitation)" @click.prevent="startEditing(invitation)"
                                   class="guest-invitation__button button button__link button__small">
                                    Edit
                                </a>

                                <a href="" v-if="false && shouldShowCopyLinkButton(invitation)" @click.prevent="copyInvitationLink(invitation)"
                                   class="guest-invitation__button button button__black button__small">
                                    Copy&nbsp;Link
                                </a>
                            </div>
                        </div>
                    </template>
                </div>

            </div>
        </div>

    </div>
`
});
Vue.component('photo-uploader', {
        props: {
            needPhoto: {
                type: Boolean,
                required: true,
            },

            needProfile: {
                type: Boolean,
                required: true,
            },
        },

        data: function () {
            return {
                userData: {
                    photos: [],
                },

                settings: {
                    showHover: false
                },

                phrases: {
                    dropMessage: PhrasesService.shared.getPhrase('signupform_dropphotosmessage')
                }
            };
        },

        methods: {
            dragOver(event) {
                event.dataTransfer.dropEffect = 'copy'
                this.settings.showHover = true
            },

            dragLeave(event) {
                this.settings.showHover = false
            },

            dropFiles(event) {
                const files = Array
                    .from(event.dataTransfer.files)
                    .filter(file => file.type.startsWith('image/'))

                this.processFiles(files)
                this.settings.showHover = false
            },

            selectFiles() {
                this.$refs.fileInput.click()
            },

            processSelectedFiles(event) {
                const files = Array
                    .from(event.target.files)
                    .filter(file => file.type.startsWith('image/'))

                this.processFiles(files)
            },

            processFiles(files) {
                for (let i = 0; i < files.length; i++) {
                    const reader = new FileReader();
                    reader.readAsDataURL(files[i]);
                    reader.onload = (event) => {

                        const img = new Image()

                        img.src = event.target.result

                        img.onload = () => {
                            let width = img.width
                            let height = img.height
                            const maxDimension = 1000

                            if (width > height && width > maxDimension) {
                                height *= maxDimension / width
                                width = maxDimension
                            } else if (height > maxDimension) {
                                width *= maxDimension / height
                                height = maxDimension
                            }

                            const canvas = document.createElement('canvas');
                            canvas.width = width;
                            canvas.height = height;
                            const ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0, width, height);

                            canvas.toBlob((blob) => {

                                const file = new File(
                                    [blob],
                                    files[i].name, {
                                    type: 'image/jpeg',
                                    lastModified: Date.now()
                                });

                                const url = URL.createObjectURL(file)

                                this.userData.photos.push({
                                    file: file,
                                    url: url
                                })

                                this.NotifyFilesUpdates()

                            }, 'image/jpeg');
                        };
                    };
                }
            },

            NotifyFilesUpdates() {
                this.$emit('files-updated', this.userData.photos);
            },
        },

        mounted() {
            
        },

        computed: {

        }
    ,
template: `
    <div class="form__upload-wrap">
        <div class="form__upload-file-list">
            <div class="form__upload-single-file" v-for="(photo, index) in userData.photos" :key="index">
                <img :src="photo.url" alt="">
            </div>
        </div>

        <div class="form__upload"
             @dragover.prevent="dragOver"
             @dragleave.prevent="dragLeave"
             @drop.prevent="dropFiles"
             @click.prevent="selectFiles"
             :class="{'hovered': settings.showHover}">
            <span class="form__upload-text form__upload-text--hover-none">📁 {{ phrases.dropMessage }}</span>
            <span class="form__upload-text form__upload-text--hover-active">📸 {{ phrases.dropMessage }}</span>
        </div>
        <input type="file" ref="fileInput" @change="processSelectedFiles" style="display: none;" multiple>
    </div>
`
});
Vue.component('sign-in', {
        props: {
            googleClientId: {
                type: String,
                required: true
            }
        },

        data: function () {
            return {
                userData: {
                    email: '',
                    emailCode: '',
                },
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null,
                    emailSent: false,
                    sendingAction: '',
                    emailDomainIsValid: true
                },
                phrases: {
                    invalidEmail: PhrasesService.shared.getPhrase('signupform_invalidemail'),
                    //email: PhrasesService.shared.getPhrase('signinform_email'),
                    //passowrd: PhrasesService.shared.getPhrase('signinform_passowrd'),
                    //login: PhrasesService.shared.getPhrase('signinform_login'),
                    emptyfield: PhrasesService.shared.getPhrase('general_emptyfield'),
                    /*useEmail: PhrasesService.shared.getPhrase('signinform_useemail'),*/
                    code: PhrasesService.shared.getPhrase('signinform_useemailcode'),

                    continueWithGoogle: PhrasesService.shared.getPhrase('signinform_continuewithgoogle'),
                    continueWithApple: PhrasesService.shared.getPhrase('signinform_continuewithapple'),
                    yourEmail: PhrasesService.shared.getPhrase('signinform_youremail'),
                    continueWithEmail: PhrasesService.shared.getPhrase('signinform_continuewithemail'),
                    changeEmail: PhrasesService.shared.getPhrase('signinform_changeemail'),
                    submitEmailLoginOtp: PhrasesService.shared.getPhrase('signinform_submitemailloginotp'),

                },
            };
        },

        methods: {
            showGoogleSignIn() {
                const isInAppBrowser = /Instagram|\[FBAN|FBAN\/FB4A|FBAV/.test(navigator.userAgent)
                return !isInAppBrowser;
            },

            async emailSignIn() {
                var _this = this
                if (this.settings.sendingData) {
                    return
                }

                this.settings.submitted = true
                this.settings.resultMessage = ''

                if (!this.userData.email.length) {
                    return
                }

                this.settings.emailDomainIsValid = await DnsService.shared.isEmailDomainValid(_this.userData.email);
                if (!this.settings.emailDomainIsValid) {
                    return;
                }

                this.settings.sendingData = true
                this.settings.sendingAction = "EmailSignIn"

                try {
                    const reCaptchaToken = await SecurityService.shared.getGoogleReCaptchaToken('user/login')

                    let response = await axios.post(
                        window._data.authUrl + 'emailsignin',
                        {
                            reCaptchaToken: reCaptchaToken,
                            email: this.userData.email,
                            languageAbbr: window._data.languageAbbr,
                            query: window.location.search
                        })

                    this.settings.succeeded = response.data.succeeded
                    this.settings.resultMessage = response.data.message

                    if (this.settings.succeeded) {
                        this.settings.emailSent = true
                        this.$refs.emailCode.focus()
                    }
                }
                catch (err) {
                    const errorMessage = err && err.message ? err.message : "Error"
                    this.settings.succeeded = false
                    this.settings.resultMessage = errorMessage
                }
                finally {
                    this.settings.sendingData = false
                }
            },

            async verifyEmailSigninCode() {
                if (this.settings.sendingData) { return }

                this.settings.submitted = true
                this.settings.resultMessage = ''
                if (!this.userData.email.length) {
                    return
                }
                this.settings.sendingData = true
                this.settings.sendingAction = "EmailCodeVerify"

                try {
                    const reCaptchaToken = await SecurityService.shared.getGoogleReCaptchaToken('user/login')

                    let response = await axios.post(
                        window._data.authUrl + 'verifyemailsignincode',
                        {
                            reCaptchaToken: reCaptchaToken,
                            email: this.userData.email,
                            code: this.userData.emailCode,
                            languageAbbr: window._data.languageAbbr,
                            query: window.location.search
                        })

                    if (response.data.succeeded) {
                        window.location.href = response.data.data.redirectUrl
                        return
                    }

                    this.settings.succeeded = response.data.succeeded
                    this.settings.resultMessage = response.data.message
                }
                catch (err) {
                    const errorMessage = err && err.message ? err.message : "Error"
                    this.settings.succeeded = false
                    this.settings.resultMessage = errorMessage
                }
                finally {
                    this.settings.sendingData = false
                    this.userData.emailCode = ''
                }
            },

            async changeEmail() {
                if (this.settings.sendingData) { return }

                this.settings.submitted = false
                this.settings.resultMessage = ''
                if (!this.userData.email.length) {
                    return
                }
                this.settings.sendingData = false
                this.userData.emailCode = ''
                //this.userData.email = ''
                this.settings.emailSent = false
                this.$refs.emailAddress.focus()
            },

            async googleSignIn() {
                GoogleService.shared.signIn(
                    this.googleClientId,

                    async (token) => {
                        var _this = this

                        if (_this.settings.sendingData) { return }
                        _this.settings.sendingData = true
                        this.settings.sendingAction = "GoogleSignIn"

                        try {
                            let response = await axios.post(
                                window._data.authUrl + 'googlesignin',
                                {
                                    token: token,
                                    languageAbbr: window._data.languageAbbr,
                                    query: window.location.search
                                })

                            if (response.data.succeeded) {
                                window.location.href = response.data.data.redirectUrl
                                return
                            }

                            _this.settings.succeeded = response.data.succeeded
                            _this.settings.resultMessage = response.data.message
                            _this.settings.sendingData = false
                        }
                        catch (err) {
                            console.error(err)
                            _this.settings.sendingData = false
                        }
                        finally {
                            _this.settings.sendingData = false
                        }
                    },

                    async (response, message) => {
                        console.error(response)
                        //alert(message)
                    }
                )
            },

            async appleSignIn() {
                if (this.settings.sendingData) { return }
                this.settings.sendingData = true
                this.settings.sendingAction = "AppleSignIn"

                let signInResult
                try {
                    signInResult = await window.AppleID.auth.signIn()
                } catch (error) {
                    console.error(error)
                    this.settings.sendingData = false
                    return
                }
                finally {

                }

                const code = signInResult.authorization.code
                const token = signInResult.authorization.id_token
                const state = signInResult.authorization.state

                try {
                    let response = await axios.post(
                        window._data.authUrl + 'applesignin',
                        {
                            token: token,
                            languageAbbr: window._data.languageAbbr,
                            query: window.location.search
                        });

                    if (response.data.succeeded) {
                        window.location.href = response.data.data.redirectUrl
                        return
                    }

                    this.settings.succeeded = response.data.succeeded
                    this.settings.resultMessage = response.data.message
                    this.settings.sendingData = false
                }
                catch (err) {
                    console.error(err)
                    this.settings.sendingData = false
                }
                finally {
                    this.settings.sendingData = false
                }
            },

            sendingDataForAction(action) {
                return this.settings.sendingData
                    && this.settings.sendingAction === action
            },

            sendingDataButNotForAction(action) {
                return this.settings.sendingData
                    && this.settings.sendingAction !== action
            },

            loadingSvg() {
                return `<svg class="loading-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="369.628" height="379.983" viewBox="0 0 369.628 379.983" class="vinyl-icon">
                        <defs>
                            <clipPath id="clip-path">
                                <path id="Clip_2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none" />
                            </clipPath>
                        </defs>
                        <g id="Group_3" data-name="Group 3" transform="translate(0 -0.482)">
                            <path id="Clip_2-2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none" />
                            <g id="Group_3-2" data-name="Group 3" clip-path="url(#clip-path)">
                                <path id="Fill_1" data-name="Fill 1" d="M23.294,189.992c-1.444,1.7-2.884,3.423-4.315,5.2A205.48,205.48,0,0,0,0,222.983a202.87,202.87,0,0,0,27.224,19.545c1.944,1.172,3.879,2.292,5.811,3.391-.782,2.1-1.553,4.216-2.3,6.379a207.408,207.408,0,0,0-8.445,32.689,200.977,200.977,0,0,0,32.185,8.94c2.223.429,4.419.81,6.606,1.174-.026,2.243-.036,4.5,0,6.79a207.922,207.922,0,0,0,3.108,33.642A200.441,200.441,0,0,0,97.45,332.79c2.234-.367,4.427-.768,6.6-1.183.734,2.117,1.487,4.24,2.29,6.382a206.51,206.51,0,0,0,14.285,30.537,201.655,201.655,0,0,0,30.332-14.1c1.975-1.118,3.9-2.256,5.806-3.4,1.4,1.735,2.83,3.47,4.308,5.2a204.077,204.077,0,0,0,23.74,23.749,204.07,204.07,0,0,0,23.74-23.749c1.453-1.7,2.852-3.409,4.233-5.114,1.892,1.128,3.8,2.25,5.761,3.353A200.593,200.593,0,0,0,249,368.525a205.43,205.43,0,0,0,14.406-30.581c.786-2.083,1.523-4.148,2.244-6.207,2.122.4,4.256.784,6.431,1.136a199.317,199.317,0,0,0,33.363,2.66,206.719,206.719,0,0,0,3.205-33.725c.035-2.23.03-4.425.011-6.609,2.129-.361,4.264-.737,6.427-1.16a199.82,199.82,0,0,0,32.25-9.053,206.26,206.26,0,0,0-8.381-32.8c-.72-2.109-1.467-4.169-2.222-6.215,1.877-1.076,3.758-2.169,5.648-3.315a201.847,201.847,0,0,0,27.246-19.674,204.372,204.372,0,0,0-18.957-27.921c-1.389-1.731-2.786-3.409-4.188-5.071,1.4-1.661,2.8-3.339,4.188-5.071A204.37,204.37,0,0,0,369.628,157a201.847,201.847,0,0,0-27.246-19.674c-1.89-1.146-3.77-2.238-5.648-3.315.755-2.047,1.5-4.107,2.222-6.215A206.275,206.275,0,0,0,347.337,95a199.766,199.766,0,0,0-32.25-9.053c-2.163-.423-4.3-.8-6.427-1.16.018-2.184.024-4.379-.011-6.609a206.713,206.713,0,0,0-3.205-33.725,199.319,199.319,0,0,0-33.363,2.66c-2.176.352-4.31.738-6.431,1.136-.721-2.059-1.457-4.124-2.244-6.207A205.4,205.4,0,0,0,249,11.458,200.541,200.541,0,0,0,218.548,25.51c-1.96,1.1-3.869,2.225-5.761,3.353-1.381-1.7-2.781-3.409-4.233-5.114A204.07,204.07,0,0,0,184.814,0a204.077,204.077,0,0,0-23.74,23.749c-1.478,1.735-2.9,3.47-4.308,5.2-1.906-1.144-3.831-2.281-5.806-3.4a201.655,201.655,0,0,0-30.332-14.1,206.485,206.485,0,0,0-14.285,30.537c-.8,2.142-1.557,4.265-2.29,6.382-2.177-.415-4.37-.817-6.6-1.183A200.383,200.383,0,0,0,64.186,44.45a207.917,207.917,0,0,0-3.108,33.642c-.031,2.291-.021,4.547,0,6.79-2.187.364-4.383.746-6.606,1.175A200.921,200.921,0,0,0,22.292,95a207.408,207.408,0,0,0,8.445,32.689c.745,2.163,1.516,4.28,2.3,6.379-1.931,1.1-3.866,2.219-5.811,3.392A202.87,202.87,0,0,0,0,157a205.548,205.548,0,0,0,18.979,27.793c1.431,1.775,2.871,3.5,4.315,5.2" transform="translate(0 0.482)" fill="#fad022" />
                            </g>
                            <path id="Fill_4" data-name="Fill 4" d="M0,139.5A139.5,139.5,0,1,1,139.5,279,139.5,139.5,0,0,1,0,139.5" transform="translate(46.5 47.5)" />
                            <path id="Fill_6" data-name="Fill 6" d="M0,61.5C0,27.535,27.31,0,61,0s61,27.535,61,61.5S94.689,123,61,123,0,95.465,0,61.5" transform="translate(122 126)" fill="#fad022" />
                            <path id="Fill_8" data-name="Fill 8" d="M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8" transform="translate(177.5 180.5)" />
                        </g>
                    </svg>`
            }
        },

        computed: {
            showChangeEmail() {
                return this.settings.emailSent
            }
        }
    ,
template: `
    <div class="form__content-wrap auth-form">
        <div class="form__divider">
            <span class="form__text">&nbsp;</span>
        </div>

        <div class="form__actions">
            <a href="" class="button button__default button__black"
               v-if="showGoogleSignIn()"
               @click.prevent="googleSignIn()"
               :class="{'loading' : sendingDataForAction('GoogleSignIn'), 'disabled': sendingDataButNotForAction('GoogleSignIn')}">
                <svg class="button__icon--auth" id="Layer_1" style="enable-background:new 0 0 56.6934 56.6934;" version="1.1" viewBox="0 0 56.6934 56.6934" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M51.981,24.4812c-7.7173-0.0038-15.4346-0.0019-23.1518-0.001c0.001,3.2009-0.0038,6.4018,0.0019,9.6017  c4.4693-0.001,8.9386-0.0019,13.407,0c-0.5179,3.0673-2.3408,5.8723-4.9258,7.5991c-1.625,1.0926-3.492,1.8018-5.4168,2.139  c-1.9372,0.3306-3.9389,0.3729-5.8713-0.0183c-1.9651-0.3921-3.8409-1.2108-5.4773-2.3649  c-2.6166-1.8383-4.6135-4.5279-5.6388-7.5549c-1.0484-3.0788-1.0561-6.5046,0.0048-9.5805  c0.7361-2.1679,1.9613-4.1705,3.5708-5.8002c1.9853-2.0324,4.5664-3.4853,7.3473-4.0811c2.3812-0.5083,4.8921-0.4113,7.2234,0.294  c1.9815,0.6016,3.8082,1.6874,5.3044,3.1163c1.5125-1.5039,3.0173-3.0164,4.527-4.5231c0.7918-0.811,1.624-1.5865,2.3908-2.4196  c-2.2928-2.1218-4.9805-3.8274-7.9172-4.9056C32.0723,4.0363,26.1097,3.995,20.7871,5.8372  C14.7889,7.8907,9.6815,12.3763,6.8497,18.0459c-0.9859,1.9536-1.7057,4.0388-2.1381,6.1836  C3.6238,29.5732,4.382,35.2707,6.8468,40.1378c1.6019,3.1768,3.8985,6.001,6.6843,8.215c2.6282,2.0958,5.6916,3.6439,8.9396,4.5078  c4.0984,1.0993,8.461,1.0743,12.5864,0.1355c3.7284-0.8581,7.256-2.6397,10.0725-5.24c2.977-2.7358,5.1006-6.3403,6.2249-10.2138  C52.5807,33.3171,52.7498,28.8064,51.981,24.4812z" /></svg>
                <span class="button__text">{{ phrases.continueWithGoogle }}</span>
                <!--<svg class="button__icon--arrow">
                    <use xlink:href="~/m/i/icons.svg#symbol-buttonarrow"></use>
                </svg>-->
                <svg-icon :html="loadingSvg()" class="loader-wrap"></svg-icon>
            </a>
            <a href="" class="button button__default button__black"
               @click.prevent="appleSignIn()"
               :class="{'loading' : sendingDataForAction('AppleSignIn'), 'disabled': sendingDataButNotForAction('AppleSignIn')}">
                <svg class="button__icon--auth" enable-background="new 0 0 56.693 56.693" id="Layer_1" version="1.1" viewBox="0 0 56.693 56.693" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M41.777,30.517c-0.062-6.232,5.082-9.221,5.312-9.372c-2.891-4.227-7.395-4.807-8.998-4.873   c-3.83-0.389-7.477,2.256-9.42,2.256c-1.939,0-4.941-2.199-8.117-2.143c-4.178,0.062-8.029,2.43-10.179,6.17   c-4.339,7.527-1.11,18.682,3.118,24.791c2.067,2.986,4.532,6.346,7.766,6.223c3.117-0.123,4.293-2.016,8.061-2.016   s4.826,2.016,8.123,1.953c3.352-0.061,5.477-3.043,7.527-6.041c2.373-3.469,3.35-6.828,3.408-6.998   C48.305,40.433,41.844,37.958,41.777,30.517z" /><path d="M35.582,12.229c1.715-2.082,2.877-4.975,2.561-7.855c-2.475,0.1-5.471,1.645-7.248,3.725   c-1.592,1.846-2.984,4.785-2.611,7.613C31.045,15.926,33.861,14.307,35.582,12.229z" /></g></svg>
                <span class="button__text">{{ phrases.continueWithApple }}</span>
                <!--<svg class="button__icon--arrow">
                    <use xlink:href="~/m/i/icons.svg#symbol-buttonarrow"></use>
                </svg>-->
                <svg-icon :html="loadingSvg()" class="loader-wrap"></svg-icon>
            </a>
        </div>

        <div class="form__divider">
            <span class="form__text">&nbsp;</span>
        </div>

        <div class="form__group">
            <div class="form__content">
                <input class="form__input" type="email" ref="emailAddress" :placeholder="phrases.yourEmail" v-model="userData.email" @keyup.enter="emailSignIn()" :disabled="settings.emailSent" />
                <label class="form__label" for="">{{ phrases.yourEmail }}</label>
                <a href="" class="form__additional-input-action" v-show="showChangeEmail" @click.prevent="changeEmail()">
                    <span class="form__additional-input-action-text">{{ phrases.changeEmail }}</span>
                </a>
            </div>
            <p class="form__invalid-field" v-show="settings.submitted && !userData.email.length">{{phrases.emptyfield}}</p>
            <p class="form__invalid-field" v-show="settings.submitted && !settings.emailDomainIsValid">{{phrases.invalidEmail}}</p>
        </div>
        <div class="form__group" v-show="settings.emailSent">
            <div class="form__content">
                <input class="form__input" type="number" pattern="[0-9]*" inputmode="numeric" ref="emailCode" :placeholder="phrases.emailCode" v-model="userData.emailCode" @keyup.enter="emailSignIn()" />
                <label class="form__label" for="">{{phrases.code}}</label>
            </div>
            <p class="form__invalid-field" v-show="settings.submitted && !userData.email.length">{{phrases.emptyfield}}</p>
        </div>

        <div class="form__message"
             :class="{'form__message--error' : !settings.succeeded, 'form__message--success' : settings.succeeded}"
             v-show="settings.resultMessage.length">
            <p>{{settings.resultMessage}}</p>
        </div>


        <div class="form__actions">
            <a href="" class="button button__default button__black"
               @click.prevent="emailSignIn()"
               :class="{'loading' : sendingDataForAction('EmailSignIn'), 'disabled' : sendingDataButNotForAction('EmailSignIn')}"
               v-show="!settings.emailSent">
                <span class="button__text">{{ phrases.continueWithEmail }}</span>
                <!--<svg class="button__icon--arrow">
                    <use xlink:href="~/m/i/icons.svg#symbol-buttonarrow"></use>
                </svg>-->
                <svg-icon :html="loadingSvg()" class="loader-wrap"></svg-icon>
            </a>
        </div>

        <div class="form__actions">
            <a href="" class="button button__default button__black"
               @click.prevent="verifyEmailSigninCode()"
               :class="{'loading' : sendingDataForAction('EmailCodeVerify'), 'disabled' : sendingDataButNotForAction('EmailCodeVerify')}"
               v-show="settings.emailSent">
                <span class="button__text">{{ phrases.submitEmailLoginOtp }}</span>
                <!--<svg class="button__icon--arrow">
                    <use xlink:href="~/m/i/icons.svg#symbol-buttonarrow"></use>
                </svg>-->
                <svg-icon :html="loadingSvg()" class="loader-wrap"></svg-icon>
            </a>
        </div>

    </div>
`
});
Vue.component('spinner', {
        props: {
            
        },
        data: function () {
            return {
            }
        },
        methods: {
           
        },

        async mounted() {
           
        },

        computed: {
            
        }
    ,
template: `
    <div class="loader-wrap">
        <svg class="loading-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="369.628" height="379.983" viewBox="0 0 369.628 379.983">
            <defs>
                <clipPath id="clip-path">
                    <path id="Clip_2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none"></path>
                </clipPath>
            </defs>
            <g id="Group_3" data-name="Group 3" transform="translate(0 -0.482)">
                <path id="Clip_2-2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none"></path>
                <g id="Group_3-2" data-name="Group 3" clip-path="url(#clip-path)">
                    <path id="Fill_1" data-name="Fill 1" d="M23.294,189.992c-1.444,1.7-2.884,3.423-4.315,5.2A205.48,205.48,0,0,0,0,222.983a202.87,202.87,0,0,0,27.224,19.545c1.944,1.172,3.879,2.292,5.811,3.391-.782,2.1-1.553,4.216-2.3,6.379a207.408,207.408,0,0,0-8.445,32.689,200.977,200.977,0,0,0,32.185,8.94c2.223.429,4.419.81,6.606,1.174-.026,2.243-.036,4.5,0,6.79a207.922,207.922,0,0,0,3.108,33.642A200.441,200.441,0,0,0,97.45,332.79c2.234-.367,4.427-.768,6.6-1.183.734,2.117,1.487,4.24,2.29,6.382a206.51,206.51,0,0,0,14.285,30.537,201.655,201.655,0,0,0,30.332-14.1c1.975-1.118,3.9-2.256,5.806-3.4,1.4,1.735,2.83,3.47,4.308,5.2a204.077,204.077,0,0,0,23.74,23.749,204.07,204.07,0,0,0,23.74-23.749c1.453-1.7,2.852-3.409,4.233-5.114,1.892,1.128,3.8,2.25,5.761,3.353A200.593,200.593,0,0,0,249,368.525a205.43,205.43,0,0,0,14.406-30.581c.786-2.083,1.523-4.148,2.244-6.207,2.122.4,4.256.784,6.431,1.136a199.317,199.317,0,0,0,33.363,2.66,206.719,206.719,0,0,0,3.205-33.725c.035-2.23.03-4.425.011-6.609,2.129-.361,4.264-.737,6.427-1.16a199.82,199.82,0,0,0,32.25-9.053,206.26,206.26,0,0,0-8.381-32.8c-.72-2.109-1.467-4.169-2.222-6.215,1.877-1.076,3.758-2.169,5.648-3.315a201.847,201.847,0,0,0,27.246-19.674,204.372,204.372,0,0,0-18.957-27.921c-1.389-1.731-2.786-3.409-4.188-5.071,1.4-1.661,2.8-3.339,4.188-5.071A204.37,204.37,0,0,0,369.628,157a201.847,201.847,0,0,0-27.246-19.674c-1.89-1.146-3.77-2.238-5.648-3.315.755-2.047,1.5-4.107,2.222-6.215A206.275,206.275,0,0,0,347.337,95a199.766,199.766,0,0,0-32.25-9.053c-2.163-.423-4.3-.8-6.427-1.16.018-2.184.024-4.379-.011-6.609a206.713,206.713,0,0,0-3.205-33.725,199.319,199.319,0,0,0-33.363,2.66c-2.176.352-4.31.738-6.431,1.136-.721-2.059-1.457-4.124-2.244-6.207A205.4,205.4,0,0,0,249,11.458,200.541,200.541,0,0,0,218.548,25.51c-1.96,1.1-3.869,2.225-5.761,3.353-1.381-1.7-2.781-3.409-4.233-5.114A204.07,204.07,0,0,0,184.814,0a204.077,204.077,0,0,0-23.74,23.749c-1.478,1.735-2.9,3.47-4.308,5.2-1.906-1.144-3.831-2.281-5.806-3.4a201.655,201.655,0,0,0-30.332-14.1,206.485,206.485,0,0,0-14.285,30.537c-.8,2.142-1.557,4.265-2.29,6.382-2.177-.415-4.37-.817-6.6-1.183A200.383,200.383,0,0,0,64.186,44.45a207.917,207.917,0,0,0-3.108,33.642c-.031,2.291-.021,4.547,0,6.79-2.187.364-4.383.746-6.606,1.175A200.921,200.921,0,0,0,22.292,95a207.408,207.408,0,0,0,8.445,32.689c.745,2.163,1.516,4.28,2.3,6.379-1.931,1.1-3.866,2.219-5.811,3.392A202.87,202.87,0,0,0,0,157a205.548,205.548,0,0,0,18.979,27.793c1.431,1.775,2.871,3.5,4.315,5.2" transform="translate(0 0.482)" fill="#fad022"></path>
                </g>
                <path id="Fill_4" data-name="Fill 4" d="M0,139.5A139.5,139.5,0,1,1,139.5,279,139.5,139.5,0,0,1,0,139.5" transform="translate(46.5 47.5)"></path>
                <path id="Fill_6" data-name="Fill 6" d="M0,61.5C0,27.535,27.31,0,61,0s61,27.535,61,61.5S94.689,123,61,123,0,95.465,0,61.5" transform="translate(122 126)" fill="#fad022"></path>
                <path id="Fill_8" data-name="Fill 8" d="M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8" transform="translate(177.5 180.5)"></path>
            </g>
        </svg>
    </div>
`
});
Vue.component('submit-additional-info', {
        props: {
            needPhoto: {
                type: Boolean,
                required: true,
            },

            needProfile: {
                type: Boolean,
                required: true,
            },

            needPersonalId: {
                type: Boolean,
                required: true,
            },
        },

        data: function () {
            return {
                userData: {
                    //firstname: '',
                    //lastname: '',
                    //birthdate: '',
                    personalId: '',
                    //phone: '',
                    photos: [],
                    socialProfile: ''
                    //acceptRules: false
                },

                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: false,
                    //hideForm: false,
                    //homeUrl: '',
                    //urlValidationElem: null
                },

                phrases: {
                    //firstname: PhrasesService.shared.getPhrase('signupform_firstname'),
                    //lastname: PhrasesService.shared.getPhrase('signupform_lastname'),
                    //email: PhrasesService.shared.getPhrase('signupform_email'),
                    //birthdate: PhrasesService.shared.getPhrase('signupform_birthdate'),
                    personalId: PhrasesService.shared.getPhrase('signupform_personalid'),
                    //phone: PhrasesService.shared.getPhrase('signupform_phone'),
                    socialProfile: PhrasesService.shared.getPhrase('signupform_facebookurl'),
                    //signup: PhrasesService.shared.getPhrase('signupform_signup'),
                    submitProfile: PhrasesService.shared.getPhrase('signupform_submitprofile'),
                    //emptyfield: PhrasesService.shared.getPhrase('general_emptyfield'),
                    //pleaseacceptrules: PhrasesService.shared.getPhrase('signupform_pleaseacceptrules'),
                    //terms: PhrasesService.shared.getPhrase('signupform_termsandconditions'),
                    //invalidProfileUrl: PhrasesService.shared.getPhrase('signupform_invalidprofileurl'),
                },

                state: {
                    profileUrlIsValid: true
                }
            };
        },

        methods: {
            photosUpdated(files) {
                this.userData.photos.length = 0
                this.userData.photos.push(...files)
            },

            async submitAdditionalInfo() {
                if (this.settings.sendingData) { return; }

                this.settings.submitted = true;
                this.settings.resultMessage = '';

                if (this.needPhoto &&
                    (!this.userData.photos || this.userData.photos.length === 0)
                ) {
                    this.settings.resultMessage = 'Please attach photos';
                    return;
                }


                if (this.needProfile &&
                    !this.userData.socialProfile.length
                ) {
                    this.settings.resultMessage = 'Please enter your social profile link';
                    return;
                }

                if (this.needPersonalId &&
                    !this.userData.personalId.length
                ) {
                    this.settings.resultMessage = 'Please enter your social profile link';
                    return;
                }

                this.settings.sendingData = true;

                try {
                    const reCaptchaToken = await SecurityService.shared.getGoogleReCaptchaToken('user/submitadditionalinfo');

                    const formData = new FormData();
                    for (let i = 0; i < this.userData.photos.length; i++) {
                        formData.append('photos', this.userData.photos[i].file);
                    }
                    formData.append('socialProfile', this.userData.socialProfile);
                    formData.append('personalId', this.userData.personalId);
                    formData.append('languageAbbr', window._data.languageAbbr);
                    formData.append('reCaptchaToken', reCaptchaToken);

                    let response = await axios.post(
                        window._data.authUrl + 'submitadditionalinfo',
                        formData
                    );

                    if (!response.data.succeeded) {
                        this.settings.succeeded = false
                        this.settings.resultMessage = response.data.message
                        return
                    }

                    window.location.reload(true)
                }
                catch (err) {
                    this.settings.succeeded = false;
                    this.settings.resultMessage = response.data.message
                    this.settings.sendingData = false
                }
                finally {
                    this.settings.sendingData = false
                }
            },

            loadingSvg() {
                return `<svg class="loading-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="369.628" height="379.983" viewBox="0 0 369.628 379.983" class="vinyl-icon">
                        <defs>
                            <clipPath id="clip-path">
                                <path id="Clip_2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none" />
                            </clipPath>
                        </defs>
                        <g id="Group_3" data-name="Group 3" transform="translate(0 -0.482)">
                            <path id="Clip_2-2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none" />
                            <g id="Group_3-2" data-name="Group 3" clip-path="url(#clip-path)">
                                <path id="Fill_1" data-name="Fill 1" d="M23.294,189.992c-1.444,1.7-2.884,3.423-4.315,5.2A205.48,205.48,0,0,0,0,222.983a202.87,202.87,0,0,0,27.224,19.545c1.944,1.172,3.879,2.292,5.811,3.391-.782,2.1-1.553,4.216-2.3,6.379a207.408,207.408,0,0,0-8.445,32.689,200.977,200.977,0,0,0,32.185,8.94c2.223.429,4.419.81,6.606,1.174-.026,2.243-.036,4.5,0,6.79a207.922,207.922,0,0,0,3.108,33.642A200.441,200.441,0,0,0,97.45,332.79c2.234-.367,4.427-.768,6.6-1.183.734,2.117,1.487,4.24,2.29,6.382a206.51,206.51,0,0,0,14.285,30.537,201.655,201.655,0,0,0,30.332-14.1c1.975-1.118,3.9-2.256,5.806-3.4,1.4,1.735,2.83,3.47,4.308,5.2a204.077,204.077,0,0,0,23.74,23.749,204.07,204.07,0,0,0,23.74-23.749c1.453-1.7,2.852-3.409,4.233-5.114,1.892,1.128,3.8,2.25,5.761,3.353A200.593,200.593,0,0,0,249,368.525a205.43,205.43,0,0,0,14.406-30.581c.786-2.083,1.523-4.148,2.244-6.207,2.122.4,4.256.784,6.431,1.136a199.317,199.317,0,0,0,33.363,2.66,206.719,206.719,0,0,0,3.205-33.725c.035-2.23.03-4.425.011-6.609,2.129-.361,4.264-.737,6.427-1.16a199.82,199.82,0,0,0,32.25-9.053,206.26,206.26,0,0,0-8.381-32.8c-.72-2.109-1.467-4.169-2.222-6.215,1.877-1.076,3.758-2.169,5.648-3.315a201.847,201.847,0,0,0,27.246-19.674,204.372,204.372,0,0,0-18.957-27.921c-1.389-1.731-2.786-3.409-4.188-5.071,1.4-1.661,2.8-3.339,4.188-5.071A204.37,204.37,0,0,0,369.628,157a201.847,201.847,0,0,0-27.246-19.674c-1.89-1.146-3.77-2.238-5.648-3.315.755-2.047,1.5-4.107,2.222-6.215A206.275,206.275,0,0,0,347.337,95a199.766,199.766,0,0,0-32.25-9.053c-2.163-.423-4.3-.8-6.427-1.16.018-2.184.024-4.379-.011-6.609a206.713,206.713,0,0,0-3.205-33.725,199.319,199.319,0,0,0-33.363,2.66c-2.176.352-4.31.738-6.431,1.136-.721-2.059-1.457-4.124-2.244-6.207A205.4,205.4,0,0,0,249,11.458,200.541,200.541,0,0,0,218.548,25.51c-1.96,1.1-3.869,2.225-5.761,3.353-1.381-1.7-2.781-3.409-4.233-5.114A204.07,204.07,0,0,0,184.814,0a204.077,204.077,0,0,0-23.74,23.749c-1.478,1.735-2.9,3.47-4.308,5.2-1.906-1.144-3.831-2.281-5.806-3.4a201.655,201.655,0,0,0-30.332-14.1,206.485,206.485,0,0,0-14.285,30.537c-.8,2.142-1.557,4.265-2.29,6.382-2.177-.415-4.37-.817-6.6-1.183A200.383,200.383,0,0,0,64.186,44.45a207.917,207.917,0,0,0-3.108,33.642c-.031,2.291-.021,4.547,0,6.79-2.187.364-4.383.746-6.606,1.175A200.921,200.921,0,0,0,22.292,95a207.408,207.408,0,0,0,8.445,32.689c.745,2.163,1.516,4.28,2.3,6.379-1.931,1.1-3.866,2.219-5.811,3.392A202.87,202.87,0,0,0,0,157a205.548,205.548,0,0,0,18.979,27.793c1.431,1.775,2.871,3.5,4.315,5.2" transform="translate(0 0.482)" fill="#fad022" />
                            </g>
                            <path id="Fill_4" data-name="Fill 4" d="M0,139.5A139.5,139.5,0,1,1,139.5,279,139.5,139.5,0,0,1,0,139.5" transform="translate(46.5 47.5)" />
                            <path id="Fill_6" data-name="Fill 6" d="M0,61.5C0,27.535,27.31,0,61,0s61,27.535,61,61.5S94.689,123,61,123,0,95.465,0,61.5" transform="translate(122 126)" fill="#fad022" />
                            <path id="Fill_8" data-name="Fill 8" d="M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8" transform="translate(177.5 180.5)" />
                        </g>
                    </svg>`;
            },

        },

        mounted() {
            this.settings.homeUrl = window._data.homeUrl;
        },

        computed: {

        }
    ,
template: `
    <div class="form">
        <div class="row" v-if="!settings.hideForm">

            <div class="col-xl-10 offset-xl-1" v-if="needPersonalId">
                <div class="form__content-wrap">
                    <div class="form__group">
                        <div class="form__content">
                            <input class="form__input" type="text" placeholder="ID or Passport Number" v-model="userData.personalId" />
                            <label class="form__label" for="">{{phrases.personalId}}</label>
                        </div>
                        <p class="form__invalid-field" v-show="settings.submitted && !userData.personalId.length">{{phrases.emptyfield}}</p>
                    </div>

                </div>
            </div>

            <div class="col-xl-10 offset-xl-1" v-if="needProfile">
                <div class="form__content-wrap">
                    <div class="form__group"></div>
                    <div class="form__group">
                        <div class="form__content">
                            <input class="form__input form__input--fb" type="text" placeholder="Social Profile Link" v-model="userData.socialProfile" />
                            <label class="form__label" for="">{{phrases.socialProfile}}</label>
                        </div>
                        <p class="form__invalid-field" v-show="settings.submitted && !userData.socialProfile.length">{{phrases.emptyfield}}</p>
                        <p class="form__invalid-field" v-show="settings.submitted && !state.profileUrlIsValid">{{phrases.invalidProfileUrl}}</p>
                    </div>
                </div>
            </div>

            <div class="col-xl-10 offset-xl-1" v-if="needPhoto">
                <div class="form__content-wrap">
                    <div class="form__group"></div>
                    <div class="form__group">
                        <photo-uploader @files-updated="photosUpdated($event)"></photo-uploader>
                    </div>
                </div>
            </div>

            <div class="col-xl-10 offset-xl-1" v-if="settings.resultMessage.length">
                <div class="form__content-wrap">
                    <div class="form__message "
                         :class="{'form__message--error' : !settings.succeeded, 'form__message--success' : settings.succeeded}">
                        <p>{{settings.resultMessage}}</p>
                    </div>
                </div>
            </div>

            <div class="col-xl-10 offset-xl-1">
                <div class="form__content-wrap">
                    <div class="form__actions">
                        <a href="" class="button button__default button__black"
                           @click.prevent="submitAdditionalInfo()"
                           :class="{'loading' : settings.sendingData}">
                            <span class="button__text">{{phrases.submitProfile}}</span>
                            <!--<svg class="button__icon--arrow">
                                <use xlink:href="~/m/i/icons.svg#symbol-buttonarrow"></use>
                            </svg>-->
                            <svg-icon :html="loadingSvg()" class="loader-wrap"></svg-icon>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('submit-profile', {
        props: {
            userEmail: {
                type: String,
                required: true,
            },
            userConcented: {
                type: Boolean,
                required: false,
            }
        },

        data: function () {
            return {
                userData: {
                    firstname: '',
                    lastname: '',
                    birthdate: '',
                    personalId: '',
                    phone: '',
                    socialProfile: '',
                    acceptRules: false,
                    photos: []
                },

                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: false,
                    showForm: false,
                    showConcentMessages: false,
                    currentConcentMessageIndex: 0,
                    homeUrl: '',
                    urlValidationElem: null
                },

                phrases: {
                    firstname: PhrasesService.shared.getPhrase('signupform_firstname'),
                    lastname: PhrasesService.shared.getPhrase('signupform_lastname'),
                    email: PhrasesService.shared.getPhrase('signupform_email'),
                    birthdate: PhrasesService.shared.getPhrase('signupform_birthdate'),
                    personalId: PhrasesService.shared.getPhrase('signupform_personalid'),
                    phone: PhrasesService.shared.getPhrase('signupform_phone'),
                    socialProfile: PhrasesService.shared.getPhrase('signupform_facebookurl'),
                    signup: PhrasesService.shared.getPhrase('signupform_signup'),
                    submitProfile: PhrasesService.shared.getPhrase('signupform_submitprofile'),
                    emptyfield: PhrasesService.shared.getPhrase('general_emptyfield'),
                    pleaseacceptrules: PhrasesService.shared.getPhrase('signupform_pleaseacceptrules'),
                    terms: PhrasesService.shared.getPhrase('signupform_termsandconditions'),
                    invalidProfileUrl: PhrasesService.shared.getPhrase('signupform_invalidprofileurl'),
                    concentTitle: PhrasesService.shared.getPhrase('concent_title'),
                    concentAgree: PhrasesService.shared.getPhrase('concent_actionagree'),
                    concentMessages: [
                        PhrasesService.shared.getPhrase('concent_message01'),
                        PhrasesService.shared.getPhrase('concent_message02'),
                        PhrasesService.shared.getPhrase('concent_message03'),
                        PhrasesService.shared.getPhrase('concent_message04')
                    ]
                },

                state: {

                }
            };
        },

        methods: {
            photosUpdated(files) {
                this.userData.photos.length = 0
                this.userData.photos.push(...files)
            },

            async agreeToMessage() {
                if (this.settings.currentConcentMessageIndex === (this.phrases.concentMessages.length - 1)) {
                    var concentSucceeded = await this.concentToRules()

                    if (concentSucceeded) {
                        // This will keep the loader spinning until the page reloads
                        this.settings.sendingData = true
                    }

                    return
                }

                if (this.settings.currentConcentMessageIndex < (this.phrases.concentMessages.length - 1)) {
                    this.settings.currentConcentMessageIndex++
                }
            },

            async concentToRules() {
                if (this.settings.sendingData) { return; }

                this.settings.sendingData = true;

                try {
                    const reCaptchaToken = await SecurityService.shared.getGoogleReCaptchaToken('user/concenttorules');
                    let response = await axios.post(
                        window._data.authUrl + 'concenttorules',
                        {
                            reCaptchaToken: reCaptchaToken,
                            languageAbbr: window._data.languageAbbr
                        });

                    if (!response.data.succeeded) {
                        this.settings.succeeded = false
                        this.settings.resultMessage = response.data.message
                        return
                    }

                    window.location.reload(true)
                    return true
                }
                catch (err) {
                    this.settings.sendingData = false
                }
                finally {
                    this.settings.sendingData = false
                }

                return false
            },

            async submitProfile() {
                var _this = this;
                if (this.settings.sendingData) { return; }

                this.settings.submitted = true;
                this.settings.resultMessage = ''
                var focusedTarget = null

                if (!this.isFirstNameValid) {
                    focusedTarget = this.$refs.inputFirstName
                }

                if (!focusedTarget && !this.isLastNameValid) {
                    focusedTarget = this.$refs.inputLastName
                }

                if (!focusedTarget && !this.isBirthdateValid) {
                    focusedTarget = this.$refs.inputBirthDate
                }

                if (!focusedTarget && !this.isSocialProfileValid) {
                    focusedTarget = this.$refs.inputSocialProfile
                }

                if (focusedTarget) {
                    console.log('focusing', focusedTarget)
                    focusedTarget.focus()
                    return
                }

                if (!this.userData.acceptRules) {
                    this.settings.resultMessage = this.phrases.pleaseacceptrules
                    return;
                }

                this.settings.sendingData = true

                try {
                    const reCaptchaToken = await SecurityService.shared.getGoogleReCaptchaToken('user/submitprofile')

                    const formData = new FormData();
                    for (let i = 0; i < this.userData.photos.length; i++) {
                        formData.append('photos', this.userData.photos[i].file)
                    }
                    formData.append('firstname', this.userData.firstname)
                    formData.append('lastname', this.userData.lastname)
                    formData.append('birthDateAsString', this.userData.birthdate)
                    formData.append('personalId', this.userData.personalId)
                    formData.append('phone', this.userData.phone)
                    formData.append('socialProfile', this.userData.socialProfile)
                    formData.append('languageAbbr', window._data.languageAbbr)
                    formData.append('reCaptchaToken', reCaptchaToken)

                    let response = await axios.post(
                        window._data.authUrl + 'submitprofile',
                        formData
                    )

                    if (!response.data.succeeded) {
                        this.settings.succeeded = false
                        this.settings.resultMessage = response.data.message
                        return
                    }

                    window.location.reload(true)
                }
                catch (err) {
                    this.settings.sendingData = false
                }
                finally {
                    this.settings.sendingData = false
                }
            },

            loadingSvg() {
                return `<svg class="loading-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="369.628" height="379.983" viewBox="0 0 369.628 379.983" class="vinyl-icon">
                        <defs>
                            <clipPath id="clip-path">
                                <path id="Clip_2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none" />
                            </clipPath>
                        </defs>
                        <g id="Group_3" data-name="Group 3" transform="translate(0 -0.482)">
                            <path id="Clip_2-2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none" />
                            <g id="Group_3-2" data-name="Group 3" clip-path="url(#clip-path)">
                                <path id="Fill_1" data-name="Fill 1" d="M23.294,189.992c-1.444,1.7-2.884,3.423-4.315,5.2A205.48,205.48,0,0,0,0,222.983a202.87,202.87,0,0,0,27.224,19.545c1.944,1.172,3.879,2.292,5.811,3.391-.782,2.1-1.553,4.216-2.3,6.379a207.408,207.408,0,0,0-8.445,32.689,200.977,200.977,0,0,0,32.185,8.94c2.223.429,4.419.81,6.606,1.174-.026,2.243-.036,4.5,0,6.79a207.922,207.922,0,0,0,3.108,33.642A200.441,200.441,0,0,0,97.45,332.79c2.234-.367,4.427-.768,6.6-1.183.734,2.117,1.487,4.24,2.29,6.382a206.51,206.51,0,0,0,14.285,30.537,201.655,201.655,0,0,0,30.332-14.1c1.975-1.118,3.9-2.256,5.806-3.4,1.4,1.735,2.83,3.47,4.308,5.2a204.077,204.077,0,0,0,23.74,23.749,204.07,204.07,0,0,0,23.74-23.749c1.453-1.7,2.852-3.409,4.233-5.114,1.892,1.128,3.8,2.25,5.761,3.353A200.593,200.593,0,0,0,249,368.525a205.43,205.43,0,0,0,14.406-30.581c.786-2.083,1.523-4.148,2.244-6.207,2.122.4,4.256.784,6.431,1.136a199.317,199.317,0,0,0,33.363,2.66,206.719,206.719,0,0,0,3.205-33.725c.035-2.23.03-4.425.011-6.609,2.129-.361,4.264-.737,6.427-1.16a199.82,199.82,0,0,0,32.25-9.053,206.26,206.26,0,0,0-8.381-32.8c-.72-2.109-1.467-4.169-2.222-6.215,1.877-1.076,3.758-2.169,5.648-3.315a201.847,201.847,0,0,0,27.246-19.674,204.372,204.372,0,0,0-18.957-27.921c-1.389-1.731-2.786-3.409-4.188-5.071,1.4-1.661,2.8-3.339,4.188-5.071A204.37,204.37,0,0,0,369.628,157a201.847,201.847,0,0,0-27.246-19.674c-1.89-1.146-3.77-2.238-5.648-3.315.755-2.047,1.5-4.107,2.222-6.215A206.275,206.275,0,0,0,347.337,95a199.766,199.766,0,0,0-32.25-9.053c-2.163-.423-4.3-.8-6.427-1.16.018-2.184.024-4.379-.011-6.609a206.713,206.713,0,0,0-3.205-33.725,199.319,199.319,0,0,0-33.363,2.66c-2.176.352-4.31.738-6.431,1.136-.721-2.059-1.457-4.124-2.244-6.207A205.4,205.4,0,0,0,249,11.458,200.541,200.541,0,0,0,218.548,25.51c-1.96,1.1-3.869,2.225-5.761,3.353-1.381-1.7-2.781-3.409-4.233-5.114A204.07,204.07,0,0,0,184.814,0a204.077,204.077,0,0,0-23.74,23.749c-1.478,1.735-2.9,3.47-4.308,5.2-1.906-1.144-3.831-2.281-5.806-3.4a201.655,201.655,0,0,0-30.332-14.1,206.485,206.485,0,0,0-14.285,30.537c-.8,2.142-1.557,4.265-2.29,6.382-2.177-.415-4.37-.817-6.6-1.183A200.383,200.383,0,0,0,64.186,44.45a207.917,207.917,0,0,0-3.108,33.642c-.031,2.291-.021,4.547,0,6.79-2.187.364-4.383.746-6.606,1.175A200.921,200.921,0,0,0,22.292,95a207.408,207.408,0,0,0,8.445,32.689c.745,2.163,1.516,4.28,2.3,6.379-1.931,1.1-3.866,2.219-5.811,3.392A202.87,202.87,0,0,0,0,157a205.548,205.548,0,0,0,18.979,27.793c1.431,1.775,2.871,3.5,4.315,5.2" transform="translate(0 0.482)" fill="#fad022" />
                            </g>
                            <path id="Fill_4" data-name="Fill 4" d="M0,139.5A139.5,139.5,0,1,1,139.5,279,139.5,139.5,0,0,1,0,139.5" transform="translate(46.5 47.5)" />
                            <path id="Fill_6" data-name="Fill 6" d="M0,61.5C0,27.535,27.31,0,61,0s61,27.535,61,61.5S94.689,123,61,123,0,95.465,0,61.5" transform="translate(122 126)" fill="#fad022" />
                            <path id="Fill_8" data-name="Fill 8" d="M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8" transform="translate(177.5 180.5)" />
                        </g>
                    </svg>`;
            },

            isUrlValid(url) {
                if (url !== "") {
                    if (!this.settings.urlValidationElem) {
                        this.settings.urlValidationElem = document.createElement('input');
                        this.settings.urlValidationElem.setAttribute('type', 'url');
                    }
                    this.settings.urlValidationElem.value = url;
                    return this.settings.urlValidationElem.validity.valid;
                }
                else {
                    return false
                }
            }

        },

        mounted() {
            this.settings.homeUrl = window._data.homeUrl
            this.settings.showForm = this.userConcented
            this.settings.showConcentMessages = !this.userConcented
        },

        computed: {
            isFirstNameValid() {
                return this.userData.firstname.length >= 2
            },

            showFirstNameInvalidMessage() {
                return this.settings.submitted && !this.isFirstNameValid
            },

            isLastNameValid() {
                return this.userData.lastname.length >= 2
            },

            showLastNameInvalidMessage() {
                return this.settings.submitted && !this.isLastNameValid
            },

            isBirthdateValid() {
                return this.userData.birthdate.length
            },

            showBirthdateInvalidMessage() {
                return this.settings.submitted && !this.isBirthdateValid
            },

            isSocialProfileValid() {
                if (!this.userData.socialProfile.length) {
                    return false
                }
                
                if (!this.isUrlValid(this.userData.socialProfile)) {
                    return false
                }

                return true
            },

            showSocialProfileInvalidMessage() {
                return this.settings.submitted && !this.isSocialProfileValid
            }
        }
    ,
template: `
    <div class="form">
        <div class="values" v-if="settings.showConcentMessages">
            <div class="profile__info-head">
                <p style="text-align: center">
                    {{ phrases.concentTitle }}
                </p>
            </div>

            <p class="values__text">
                {{ phrases.concentMessages[settings.currentConcentMessageIndex] }}
            </p>

            <a href="" class="button button__default button__black button__inline-arrow"
               @click.prevent="agreeToMessage()"
               :class="{'loading' : settings.sendingData}">
                <span class="button__text" v-html="phrases.concentAgree + '&nbsp;&nbsp;(' + (settings.currentConcentMessageIndex + 1) + '/' + phrases.concentMessages.length + ')'"></span>
                <div class="loader-wrap">
                    <svg class="loading-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="369.628" height="379.983" viewBox="0 0 369.628 379.983">
                        <defs>
                            <clipPath id="clip-path">
                                <path id="Clip_2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none"></path>
                            </clipPath>
                        </defs>
                        <g id="Group_3" data-name="Group 3" transform="translate(0 -0.482)">
                            <path id="Clip_2-2" data-name="Clip 2" d="M0,0H369.628V379.983H0Z" transform="translate(0 0.482)" fill="none"></path>
                            <g id="Group_3-2" data-name="Group 3" clip-path="url(#clip-path)">
                                <path id="Fill_1" data-name="Fill 1" d="M23.294,189.992c-1.444,1.7-2.884,3.423-4.315,5.2A205.48,205.48,0,0,0,0,222.983a202.87,202.87,0,0,0,27.224,19.545c1.944,1.172,3.879,2.292,5.811,3.391-.782,2.1-1.553,4.216-2.3,6.379a207.408,207.408,0,0,0-8.445,32.689,200.977,200.977,0,0,0,32.185,8.94c2.223.429,4.419.81,6.606,1.174-.026,2.243-.036,4.5,0,6.79a207.922,207.922,0,0,0,3.108,33.642A200.441,200.441,0,0,0,97.45,332.79c2.234-.367,4.427-.768,6.6-1.183.734,2.117,1.487,4.24,2.29,6.382a206.51,206.51,0,0,0,14.285,30.537,201.655,201.655,0,0,0,30.332-14.1c1.975-1.118,3.9-2.256,5.806-3.4,1.4,1.735,2.83,3.47,4.308,5.2a204.077,204.077,0,0,0,23.74,23.749,204.07,204.07,0,0,0,23.74-23.749c1.453-1.7,2.852-3.409,4.233-5.114,1.892,1.128,3.8,2.25,5.761,3.353A200.593,200.593,0,0,0,249,368.525a205.43,205.43,0,0,0,14.406-30.581c.786-2.083,1.523-4.148,2.244-6.207,2.122.4,4.256.784,6.431,1.136a199.317,199.317,0,0,0,33.363,2.66,206.719,206.719,0,0,0,3.205-33.725c.035-2.23.03-4.425.011-6.609,2.129-.361,4.264-.737,6.427-1.16a199.82,199.82,0,0,0,32.25-9.053,206.26,206.26,0,0,0-8.381-32.8c-.72-2.109-1.467-4.169-2.222-6.215,1.877-1.076,3.758-2.169,5.648-3.315a201.847,201.847,0,0,0,27.246-19.674,204.372,204.372,0,0,0-18.957-27.921c-1.389-1.731-2.786-3.409-4.188-5.071,1.4-1.661,2.8-3.339,4.188-5.071A204.37,204.37,0,0,0,369.628,157a201.847,201.847,0,0,0-27.246-19.674c-1.89-1.146-3.77-2.238-5.648-3.315.755-2.047,1.5-4.107,2.222-6.215A206.275,206.275,0,0,0,347.337,95a199.766,199.766,0,0,0-32.25-9.053c-2.163-.423-4.3-.8-6.427-1.16.018-2.184.024-4.379-.011-6.609a206.713,206.713,0,0,0-3.205-33.725,199.319,199.319,0,0,0-33.363,2.66c-2.176.352-4.31.738-6.431,1.136-.721-2.059-1.457-4.124-2.244-6.207A205.4,205.4,0,0,0,249,11.458,200.541,200.541,0,0,0,218.548,25.51c-1.96,1.1-3.869,2.225-5.761,3.353-1.381-1.7-2.781-3.409-4.233-5.114A204.07,204.07,0,0,0,184.814,0a204.077,204.077,0,0,0-23.74,23.749c-1.478,1.735-2.9,3.47-4.308,5.2-1.906-1.144-3.831-2.281-5.806-3.4a201.655,201.655,0,0,0-30.332-14.1,206.485,206.485,0,0,0-14.285,30.537c-.8,2.142-1.557,4.265-2.29,6.382-2.177-.415-4.37-.817-6.6-1.183A200.383,200.383,0,0,0,64.186,44.45a207.917,207.917,0,0,0-3.108,33.642c-.031,2.291-.021,4.547,0,6.79-2.187.364-4.383.746-6.606,1.175A200.921,200.921,0,0,0,22.292,95a207.408,207.408,0,0,0,8.445,32.689c.745,2.163,1.516,4.28,2.3,6.379-1.931,1.1-3.866,2.219-5.811,3.392A202.87,202.87,0,0,0,0,157a205.548,205.548,0,0,0,18.979,27.793c1.431,1.775,2.871,3.5,4.315,5.2" transform="translate(0 0.482)" fill="#fad022"></path>
                            </g>
                            <path id="Fill_4" data-name="Fill 4" d="M0,139.5A139.5,139.5,0,1,1,139.5,279,139.5,139.5,0,0,1,0,139.5" transform="translate(46.5 47.5)"></path>
                            <path id="Fill_6" data-name="Fill 6" d="M0,61.5C0,27.535,27.31,0,61,0s61,27.535,61,61.5S94.689,123,61,123,0,95.465,0,61.5" transform="translate(122 126)" fill="#fad022"></path>
                            <path id="Fill_8" data-name="Fill 8" d="M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8" transform="translate(177.5 180.5)"></path>
                        </g>
                    </svg>
                </div>
            </a>
        </div>
        <div class="row" v-if="settings.showForm">
            <div class="col-12">
                <br /><br />
            </div>
            <div class="col-xl-6">
                <div class="form__content-wrap">
                    <div class="form__group">
                        <div class="form__content">
                            <input class="form__input" type="text" v-model="userData.firstname" ref="inputFirstName" :disabled="settings.sendingData" />
                            <label class="form__label" for="">
                                {{phrases.firstname }}*
                            </label>
                        </div>
                        <p class="form__invalid-field" v-show="showFirstNameInvalidMessage">{{phrases.emptyfield}}</p>
                    </div>

                    <div class="form__group">
                        <div class="form__content">
                            <input class="form__input" type="text" v-model="userData.lastname" ref="inputLastName" :disabled="settings.sendingData" />
                            <label class="form__label" for="">{{phrases.lastname}}*</label>
                        </div>
                        <p class="form__invalid-field" v-show="showLastNameInvalidMessage">{{phrases.emptyfield}}</p>
                    </div>
                </div>
            </div>

            <div class="col-xl-6">
                <div class="form__content-wrap">

                    <div class="form__group">
                        <div class="form__content">
                            <input class="form__input" type="date" v-model="userData.birthdate" ref="inputBirthDate" :disabled="settings.sendingData" />
                            <label class="form__label" for="">{{phrases.birthdate}}*</label>
                        </div>
                        <p class="form__invalid-field" v-show="showBirthdateInvalidMessage">{{phrases.emptyfield}}</p>
                    </div>


                    <div class="form__group">
                        <div class="form__content">
                            <input class="form__input form__input--fb" type="text" v-model="userData.socialProfile" ref="inputSocialProfile" :disabled="settings.sendingData" />
                            <label class="form__label" for="">{{phrases.socialProfile}}*</label>
                        </div>
                        <p class="form__invalid-field" v-show="showSocialProfileInvalidMessage">{{phrases.invalidProfileUrl}}</p>
                    </div>

                </div>
            </div>

            <div class="col-xl-6">
                <div class="form__content-wrap">
                    <div class="form__group"></div>
                    <div class="form__group">
                        <div class="form__content">
                            <input class="form__input" type="text" v-model="userData.personalId" :disabled="settings.sendingData" />
                            <label class="form__label" for="">{{phrases.personalId}}</label>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-xl-6">
                <div class="form__content-wrap">
                    <div class="form__group"></div>
                    <div class="form__group">
                        <div class="form__content">
                            <input class="form__input" type="text" v-model="userData.phone" :disabled="settings.sendingData" />
                            <label class="form__label" for="">{{phrases.phone}}</label>


                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="form__group"></div>
                <div class="form__group">
                    <div class="form__content">
                        <photo-uploader @files-updated="photosUpdated($event)"></photo-uploader>
                    </div>
                </div>
            </div>

            <div class="col-12" v-if="settings.resultMessage.length">
                <div class="form__message"
                     :class="{'form__message--error' : !settings.succeeded, 'form__message--success' : settings.succeeded}">
                    <p>{{settings.resultMessage}}</p>
                </div>
            </div>

            <div class="col-xl-6">
                <div class="form__actions">
                    <div class="checkbox-holder">
                        <div class="checkbox">
                            <input id="terms" name="terms" type="checkbox" class="checkbox__input" v-model="userData.acceptRules">
                            <label for="terms" class="checkbox__label">
                                <span class="checkbox__icon-wrap">
                                    <span class="checkbox__icon"></span>
                                </span>
                                <span class="checkbox__text" v-html="phrases.terms.replace('<p>', '').replace('</p>', '')">

                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-6">
                <div class="form__actions">
                    <a href="" class="button button__default button__black button__inline-arrow"
                       @click.prevent="submitProfile()"
                       :class="{'loading' : settings.sendingData}">
                        <span class="button__text">{{phrases.submitProfile}}</span>
                        <!--<svg class="button__icon--arrow">
                            <use xlink:href="~/m/i/icons.svg#symbol-buttonarrow"></use>
                        </svg>-->
                        <svg-icon :html="loadingSvg()" class="loader-wrap"></svg-icon>
                    </a>
                    <!--<a href="#" class="form__delete-account">Delete my account and personal data</a>-->
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('svg-icon', {
        props: ['html'],
        data: function () {},
        methods: {
        },
        mounted() {
        }
    ,
template: `
    <div v-html="html">
    </div>
`
});
(function (target) {
    var vueAppContainers = document.querySelectorAll('*[data-vue-app]');

    [].forEach.call(vueAppContainers, function (vueAppContainer) {
        new Vue({
            el: vueAppContainer
        });
    });
})(window);
setTimeout(function () {
    svg4everybody();

    $('.js-responsive-header-trigger').on('click', function () {
        var _this = $(this);
        var _results = $('.js-responsive-header-results');
        _this.parents('.header__burger').toggleClass('open');
        _results.stop().slideToggle();
        $('body').toggleClass('noscroll');
        return false;
    });

    var processSidebarSticky = function () {
        var gap = 40;
        $('.section__sidebar').each(function () {
            var $contentElem = $(this).find('.section__sidebar-content');
            var $iconElem = $(this).find('.section__actions');
            var iconHeight = $iconElem.outerHeight();
            $contentElem.css('padding-block', (iconHeight + gap) + 'px');
        });
    }
    processSidebarSticky();
    $(window).on('resize', processSidebarSticky);

    // Hash anchor navigation
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const offsetHeight = $('header').outerHeight();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offsetHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        });
    });

}, 200);

function createAndSubmitUfcPaymentForm(url, transId, newTab) {
    const targetAttribute = !!newTab ? 'target="_blank"' : '';
    const html =
        '<form id="payform" action="' +
        url +
        '" method="post" name="returnform" ' +
        targetAttribute +
        '><input type="hidden" name="trans_id" value="' +
        transId +
        '" /></form>';
    $("body").append(html);
    $("#payform")[0].submit();
};

function payTicket(element, ticketId, title, productId, price) {
    if ($(element).hasClass('loading')) {
        return;
    }
    
    $(element).addClass('loading');

    fbq('track', 'PayTicket', {
        content_name: title,
        content_category: 'Event',
        content_ids: [productId],
        content_type: 'product',
        value: price,
        currency: 'USD'
    });

    $.ajax({
        type: "POST",
        contentType: "application/json",
        url: window._data.ticketApiUrl + 'payticket',
        dataType: 'json',
        processData: false,
        data: JSON.stringify({
            'ticketId': ticketId,
            'languageAbbr': window._data.languageAbbr,
            'source': window.location.pathname
        })
    }).done(function (e) {
        if (e.succeeded) {
            if (e.data.result == 1) {
                createAndSubmitUfcPaymentForm(e.data.redirectUrl, e.data.transactionId);
            } else {
                location.href = e.data.redirectUrl;
            }
        }

        throw e
    }).fail(function (e) {
        console.error(e)
    }).always(function () {
        $(_this).removeClass('loading')
    });
}
